<template>
  <div class="component-upload-image">
    <ul class="el-upload-list el-upload-list--picture-card" v-if="fileList.length > 0">
      <draggable v-model="fileList" :disabled="readonly" @end="onDraggEnd">
        <li v-for="(item, index) in fileList" :key="index" class="el-upload-list__item is-success animated">
          <img :src="item.url" alt="" class="el-upload-list__item-thumbnail" />
          <i class="el-icon-close"></i>
          <span class="el-upload-list__item-actions">
            <!-- 预览 -->
            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <!-- 删除 -->
            <span class="el-upload-list__item-delete" v-if="!readonly" @click="handleDelete(item)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </li>
      </draggable>
    </ul>
    <el-upload v-if="!readonly" multiple action="" :http-request="uploadFileRequest" list-type="picture-card"
      :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :limit="limit" :accept="accept"
      :disabled="disabled" :on-error="handleUploadError" :on-exceed="handleExceed" ref="imageUploadRef"
      :show-file-list="false" :headers="headers" :file-list="fileList" :on-preview="handlePictureCardPreview"
      :class="{ hide: fileList.length >= limit, 'disabled': disabled }">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- 上传提示 -->
    <div class="el-upload__tip" v-if="showTip && !readonly">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
      </template>
      <template v-if="fileType">
        格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
      </template>
      的图片
    </div>
    <el-image-viewer v-if="dialogVisible" :url-list="[dialogImageUrl]" :on-close="handlePicturePreviewClose" />
  </div>
</template>

<script>
  import axios from 'axios';

  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import draggable from 'vuedraggable'

  export default {
    name: 'MultiImg',
    components: {
      ElImageViewer,
      draggable
    },
    props: {
      value: {
        type: [String, Object, Array]
      },
      limit: {
        type: Number,
        default: 9
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isShowTip: {
        type: Boolean,
        default: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      fileSize: {
        type: Number,
        default: 5
      },
      fileType: {
        type: Array,
        default: () => ["png", "jpg", "jpeg", "webp", "gif"]
      },
      returnField: {
        type: String,
        default: 'url'
      },
    },
    data() {
      return {
        uploadImg: process.env.VUE_APP_BASE_API + '/fileUpload/uploadImg',
        headers: {},

        number: 0,
        uploadList: [],
        fileList: [],

        dialogVisible: false,
        dialogImageUrl: '',

        loadings: null,
      }
    },
    computed: {
      accept() {
        if (this.fileType.length == 0) return '';
        return this.fileType.map(t => `.${t}`).join(',');
      },
      showTip() {
        return this.isShowTip && (this.fileType || this.fileSize)
      }
    },
    watch: {
      value: {
        async handler(val, oldVal) {
          if (val) {
            // 首先将值转为数组
            let list = [];
            if (Array.isArray(val)) {
              list = val;
            } else if (typeof val === "string" && val.indexOf(',') > -1 && this.returnField === 'url') {
              list = val.split(',')
            } else if (typeof val === "string" && val.startsWith('http')) {
              list = [val]
            } else {
              const res = await listByIds(val)
              list = res.data
            }
            // 然后将数组转为对象数组
            this.fileList = list.map(item => {
              // 字符串回显处理 如果此处存的是url可直接回显 如果存的是id需要调用接口查出来
              let itemData;
              if (typeof item === "string") {
                itemData = {
                  name: item,
                  url: item
                };
              } else {
                // 此处name使用ossId 防止删除出现重名
                itemData = {
                  name: item.ossId,
                  url: item.url,
                  ossId: item.ossId
                };
              }
              return itemData;
            });
          } else {
            this.fileList = [];
            return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      loading(text) {
        this.loadings = this.$loading({
          lock: true,
          text: text,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
      },
      closeLoading() {
        if (this.loadings) {
          this.loadings.close()
        }
      },

      /** 上传前loading加载 */
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some((type) => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }
        if (!isImg) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式的图片!`)
          return false;
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$message.error(`上传图片大小不能超过 ${this.fileSize} MB!`)
            return false;
          }
        }
        this.loading("正在上传图片，请稍候...");
        this.number++;
      },

      // 文件个数超出
      handleExceed() {
        this.$messageerror(`上传图片数量不能超过 ${this.limit} 个!`)
      },

      // 上传成功回调
      handleUploadSuccess(res, file) {
        if (res.status == 200) {
          this.uploadList.push({
            name: res.data.imgname,
            url: res.data.img_url.replace('localhost', '192.168.3.157'),
            ossId: res.data.dImgid
          });
          this.uploadedSuccessfully();
        } else {
          this.number--;
          this.closeLoading();
          this.$message.error(res.msg)
          this.$refs.imageUploadRef.handleRemove(file);
          this.uploadedSuccessfully();
        }
      },

      // 删除图片
      handleDelete(file) {
        const findex = this.fileList.map(f => f.name).indexOf(file.name);
        if (findex > -1 && this.uploadList.length === this.number) {
          this.fileList.splice(findex, 1);
          this.$emit('input', this.listToString(this.fileList))
          return false;
        }
        return true;
      },

      // 上传结束处理
      uploadedSuccessfully() {
        if (this.number > 0 && this.uploadList.length === this.number) {
          this.fileList = this.fileList.filter(f => f.url !== undefined).concat(this.uploadList);
          this.uploadList = [];
          this.number = 0;
          this.$emit('input', this.listToString(this.fileList))
          this.closeLoading();
        }
      },

      // 上传失败
      handleUploadError() {
        this.$message.error('上传图片失败')
        this.closeLoading();
      },

      // 预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        // 解决滚动穿透问题
        document.body.style.overflow = 'hidden';
      },

      // 关闭预览
      handlePicturePreviewClose() {
        this.dialogVisible = false;
        document.body.style.overflow = '';
      },

      // 对象转成指定字符串分隔
      listToString(list, separator) {
        let strs = "";
        separator = separator || ",";
        for (let i in list) {
          if (undefined !== list[i][this.returnField] && list[i].url.indexOf("blob:") !== 0) {
            strs += list[i][this.returnField] + separator;
          }
        }
        return strs != "" ? strs.substring(0, strs.length - 1) : "";
      },

      // 重写上传请求
      async uploadFileRequest(params) {
        const {
          file
        } = params;
        this.uploadApi(file).then(res => {
          this.handleUploadSuccess(res, file);
        }).catch(error => {
          // console.log(error)
          this.handleUploadError(error, file);
          this.$refs.imageUploadRef.handleRemove(file);
        });
      },

      uploadApi(file) {
        const config = {
          timeout: 1000 * 60 * 15,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        const formData = new FormData();
        formData.append('file', file);
        return new Promise((resolve, reject) => {
          axios
            .post(this.uploadImg, formData, config)
            .then((resp) => {
              // console.log(resp.data)
              if (resp.data && resp.data.status == 200) {
                resolve(resp.data);
              } else {
                reject(resp);
              }
            }).catch((err) => reject(err));
        });
      },

      // 拖拽结束
      onDraggEnd(e) {
        this.$emit('input', this.listToString(this.fileList))
      },

    },
  }
</script>

<style scoped lang="scss">
  // .el-upload--picture-card 控制加号部分
  ::v-deep .el-upload--picture-card {
    width: 80px !important;
    height: 80px !important;
    line-height: 90px !important;
  }

  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }

  ::v-deep .el-upload-list__item {
    width: 80px !important;
    height: 80px !important;
    background-color: #f8f8f8 !important;
  }

  .disabled {
    ::v-deep .el-upload {
      cursor: not-allowed;
      border: 1px dashed var(--el-border-color-darker);
      color: #6e6e6e;
    }

    ::v-deep .el-upload-list {
      margin-top: 0;
    }

    .upload-file-item {
      margin-top: 0;
    }
  }
</style>
